import fetch from "@/common/js/http";

const project = {
  namespaced: true,
  mutations: {},
  actions: {
    getAllProject({ commit }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/all",
          method: "get",
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    getlistWithPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/page",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    exportCurrent({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/download",
          method: "get",
          params:params,
          responseType: "blob",
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    getDeptList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/dept",
          method: "get",
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    getOtherData({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/otherCost",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    deleteOtherCost({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/otherCost",
          method: "delete",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    addOtherCost({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/otherCost",
          method: "post",
          data: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    updateOtherCost({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/otherCost",
          method: "put",
          data: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    createProject({ commit }, proj) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project",
          method: "put",
          data: proj,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    saveProject({ cmmmit }, proj) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project",
          method: "post",
          data: proj,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    deleteProject({ cmmmit }, id) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/" + id,
          method: "delete",
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },

    isDeleteUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/delete",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // 获取项目执行管理-更新记录
    getUpdataList({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/projectComments/all",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // 进度补录
    progressrate({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/progressrate",
          method: "post",
          data: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // 删除进度补录
    progressratedel({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/progressratedel",
          method: "DELETE",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // 项目信息回复
    addProjectComments({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/addProjectComments",
          method: "post",
          data: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // 删除评论
    deleteProjectComments({ commit }, id) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/deleteProjectComments/" + id,
          method: "delete",
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    // /api/project/processHistory?projectId=projectId
    // 进度变更
    getProcessHistory({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/processHistory",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    /*******************************微信*********************************/
    // 获取项目信息详情
    getProjectDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/detail",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    saveProjectDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/update",
          method: "post",
          data: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    getWxProjectList({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/list",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    checkProjectHours({ commit }, params) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/hours",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },

    workHours({ commit }, { params, method }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "projectworktime",
          method: method,
          data: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },

    //获取角色
    queryRole({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "worktimerole/list",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },

    //获取项目工时信息
    queryProjectHours({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "projectworktime",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    //获取项目UT起止时间
    queryProjectStartEndTime({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/utinfo/new",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },

    //查询角色下对应的Level
    queryLevel({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "user/levelConfig/all",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    //获取预览
    getPreviewData({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/process/preview",
          method: "get",
          params: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    //生成刷新
    doFresh({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        return fetch({
          url: "project/process/preview",
          method: "post",
          data: params,
        }).then(
          (success) => {
            resolve(success);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
  },
};

export default project;



// WEBPACK FOOTER //
// ./src/vuex/modules/project.js